export default __webpack_public_path__ + "2763f8d03f70562e0744f6e86a895779.svg";